import { getApiClient } from "@src/api";
import { graphql } from "@src/gql";
import { KnownUserRanklists } from "@src/gql/graphql";
import { queryOptions } from "@tanstack/react-query";
import { WhiteboardListingSchema } from "../schema";
import { whiteboardQueryKeys } from "./query-keys";
import { ensureValidRankings } from "./ranklist-utils";

const fetchActiveWhiteboardsQuery = graphql(/* GraphQL */ `
	query fetchActiveWhiteboards($userId: String!, $shareKey: String) {
		whiteboards {
			list(
				orderByRankList: MY_WHITEBOARDS
				shareKey: $shareKey
				where:  {
					ownerId:  {
						eq: $userId
					}
					or: [
						{ status: { eq: ACTIVE } }
					]
				}
			) {
				...WhiteboardDetailsFragment
			}
		}
	}
`);

export const fetchActiveWhiteboardsQueryFn = async (
	userId: string,
	shareKey: string | null = null,
) => {
	const client = getApiClient();

	const response = await client.query({
		query: fetchActiveWhiteboardsQuery,
		variables: { userId, shareKey },
	});

	const whiteboards = WhiteboardListingSchema.parse(
		response.data?.whiteboards.list,
	);

	return await ensureValidRankings(
		whiteboards,
		KnownUserRanklists.MyWhiteboards,
	);
};

export const fetchActiveWhiteboardsQueryOptions = (
	userId: string,
	shareKey: string | null = null,
) => {
	return queryOptions({
		queryKey: whiteboardQueryKeys.active(userId, shareKey),
		queryFn: () => fetchActiveWhiteboardsQueryFn(userId, shareKey),
		networkMode: "offlineFirst",
	});
};
